import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-171cdf47"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  href: "https://pf.kakao.com/_uzWxoxj",
  target: "_blank"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: "https://static-s.theckb.com/BusinessMarket/Client/login/kakao.png"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "channel-name" }, "카카오톡 채널", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "channel-id" }, "THE CKB_KOREA", -1))
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: "https://static-s.theckb.com/BusinessMarket/Client/login/Line.png"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "channel-name" }, "Line Official Account", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "channel-id" }, "THE直行便", -1))
const _hoisted_9 = {
  key: 2,
  href: "https://teams.live.com/free",
  target: "_blank"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: "https://static-s.theckb.com/BusinessMarket/Client/login/Skype.png"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "channel-name" }, "Skype Official Account", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "channel-id" }, "THE CKB_KOREA", -1))

import { onMounted, ref } from 'vue'
import { useSite, isJA, isKO, isEN } from '@/store'
import { lineUrl } from '@/common/const'

export default /*#__PURE__*/_defineComponent({
  props: ['type', 'h5'],
  setup(__props) {

const clientHeight = ref(550)

onMounted(() => {
  if (document.body.clientHeight >= 600) {
    clientHeight.value = document.body.clientHeight
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "contactUS",
    style: _normalizeStyle(clientHeight.value >= 600
    ? ''
    : 'bottom:35vw;right:10px'
    )
  }, [
    (_unref(isKO)())
      ? (_openBlock(), _createElementBlock("a", _hoisted_1, [
          _createVNode(_component_el_tooltip, {
            disabled: __props.h5,
            effect: "dark",
            placement: "bottom-end"
          }, {
            content: _withCtx(() => [
              _hoisted_3,
              _hoisted_4
            ]),
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    (_unref(isJA)())
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: _unref(lineUrl),
          target: "_blank"
        }, [
          _createVNode(_component_el_tooltip, {
            disabled: __props.h5,
            effect: "dark",
            placement: "bottom-end"
          }, {
            content: _withCtx(() => [
              _hoisted_7,
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 8, _hoisted_5))
      : _createCommentVNode("", true),
    (_unref(isEN)())
      ? (_openBlock(), _createElementBlock("a", _hoisted_9, [
          _createVNode(_component_el_tooltip, {
            disabled: __props.h5,
            effect: "dark",
            placement: "bottom-end"
          }, {
            content: _withCtx(() => [
              _hoisted_11,
              _hoisted_12
            ]),
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})